import { useEffect, useState } from 'react';
import { koreanRegions } from '@/mocks/koreanRegions';

interface RegionSelectProps {
  value: string;
  onChange: (value: string) => void;
}

const selectClass =
  'w-full cursor-pointer rounded-md border border-background-300 bg-background-50 px-3 py-2.5 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-500 focus:ring-2 focus:ring-primary-200';

export default function RegionSelect({ value, onChange }: RegionSelectProps) {
  const [sido, setSido] = useState('');
  const [sigungu, setSigungu] = useState('');

  useEffect(() => {
    const trimmed = (value || '').trim();
    if (!trimmed) {
      setSido('');
      setSigungu('');
      return;
    }
    const group = koreanRegions.find((g) => trimmed.startsWith(g.sido));
    if (group) {
      setSido(group.sido);
      setSigungu(trimmed.slice(group.sido.length).trim());
    }
  }, [value]);

  const group = koreanRegions.find((g) => g.sido === sido);
  const sigunguList = group?.sigungu ?? [];

  function handleSido(nextSido: string) {
    setSido(nextSido);
    setSigungu('');
    const nextGroup = koreanRegions.find((g) => g.sido === nextSido);
    if (nextGroup && nextGroup.sigungu.length === 0) {
      onChange(nextSido);
    } else {
      onChange('');
    }
  }

  function handleSigungu(next: string) {
    setSigungu(next);
    if (next) {
      onChange(`${sido} ${next}`);
    }
  }

  return (
    <div className="grid grid-cols-2 gap-2">
      <select value={sido} onChange={(e) => handleSido(e.target.value)} className={selectClass}>
        <option value="">시/도 선택</option>
        {koreanRegions.map((g) => (
          <option key={g.sido} value={g.sido}>
            {g.sido}
          </option>
        ))}
      </select>

      {sigunguList.length === 0 ? (
        <div className="flex items-center rounded-md border border-background-300 bg-background-100 px-3 py-2.5 text-sm text-foreground-400">
          시·군·구 구분 없음
        </div>
      ) : (
        <select
          value={sigungu}
          onChange={(e) => handleSigungu(e.target.value)}
          className={selectClass}
        >
          <option value="">시/군/구 선택</option>
          {sigunguList.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>
      )}
    </div>
  );
}